import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon, IconDirectionality } from './tools';
export const Close = createSvgIcon('0 0 20 20', IconDirectionality.All, _jsx("path", { fill: 'currentColor', d: 'm15.833 5.341-1.175-1.175L10 8.824 5.342 4.166 4.167 5.341l4.658 4.658-4.658 4.659 1.175 1.175L10 11.174l4.658 4.659 1.175-1.175-4.658-4.659z' }));
